var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1777 6.44531L15.1887 3.4957C14.8681 3.1793 14.4335 3 13.9811 3H6.71C5.76594 3.00352 5 3.75937 5 4.69102V19.316C5 20.2477 5.76594 21.0035 6.71 21.0035H16.97C17.9141 21.0035 18.68 20.2477 18.68 19.316V7.64062C18.68 7.19414 18.4983 6.76172 18.1777 6.44531ZM17.3726 7.24336C17.4474 7.31719 17.4972 7.40508 17.5222 7.50352H14.12V4.14609C14.2197 4.1707 14.3088 4.21992 14.3836 4.29375L17.3726 7.24336ZM16.97 19.8785H6.71C6.3965 19.8785 6.14 19.6254 6.14 19.316V4.69102C6.14 4.38164 6.3965 4.12852 6.71 4.12852H12.98V7.78477C12.98 8.25234 13.3612 8.62852 13.835 8.62852H17.54V19.316C17.54 19.6254 17.2835 19.8785 16.97 19.8785Z",
    fill: "#0e0333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLink);
export default __webpack_public_path__ + "static/media/icon-link.547e3b4fa949ff516932dba477b681f7.svg";
export { ForwardRef as ReactComponent };